<template>
  <div class="top-bar">
    <v-slide-y-transition
      v-for="(notification, index) in notifications"
      :key="index"
    >
      <v-alert
        :type="notification.severity"
        value="true"
        @click="hideNotification(index)"
      >
        {{ notification.message }}
      </v-alert>
    </v-slide-y-transition>
  </div>
</template>

<script>
// import vuex mapping
import { mapMutations, mapGetters } from 'vuex'
// our new component
export default {
  name: 'Notifications',
  computed: {
    ...mapGetters({
      notifications: 'info/notifications'
    })
  },
  methods: {
    ...mapMutations({
      hideNotification: 'info/hideNotification'
    })
  }
}
</script>
